// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm icons:create to update
// Do not edit
import type { SVGProps } from 'react';

export const IconRubbishBinSvg = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.167 5c0-.46.373-.833.833-.833h10c.46 0 .833.373.833.833v11.667c0 .92-.746 1.667-1.666 1.667H5.833c-.92 0-1.666-.747-1.666-1.667V5Zm1.666.834v10.833h8.334V5.834H5.833Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5 5c0-.46.373-.833.833-.833h13.334a.833.833 0 0 1 0 1.667H3.333A.833.833 0 0 1 2.5 5Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.833 3.334c0-.92.746-1.667 1.667-1.667h5c.92 0 1.667.746 1.667 1.667V5c0 .46-.373.834-.834.834H6.667A.833.833 0 0 1 5.833 5V3.334Zm6.667 0h-5v.833h5v-.833Z"
      clipRule="evenodd"
    />
  </svg>
);
